import Section, { SectionVisibilityProps } from './Section';
import { useTranslation } from 'react-i18next';
import React from 'react';
import PaymentMethod from '../../payment/payment-methods/PaymentMethod';
import classnames from 'classnames';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';
import PaymentMethodBrandIcons from '../../payment/payment-methods/PaymentMethodBrandIcons';
import { SectionType } from './CheckoutInfoBag';
import usePaymentCoordinator from '../../../hooks/payment/usePaymentCoordinator';
import useAllergens from '../../../hooks/menu/useAllergens';
import { PaymentMethod as PaymentMethods } from '../../../services/exports/Constants';

export default function PaymentInfoSection({ show }: SectionVisibilityProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Checkout:Sections:PaymentInfoSection' });

  const { selectedPaymentMethod, paymentOptions, setSelectedPaymentMethod } = usePaymentFlow();
  const { loading } = usePaymentCoordinator();
  const { shouldShowAllergensConfirmationModal, setShowAllergensConfirmationModal } = useAllergens();

  const onPaymentMethodClick = (paymentMethod: PaymentMethods) => {
    if (shouldShowAllergensConfirmationModal) {
      return setShowAllergensConfirmationModal(true);
    }

    setSelectedPaymentMethod(paymentMethod);
  };

  return (
    <Section
      show={show}
      id={SectionType.payment_info}
      title={t('title')}
      description={t('description')}
      hideDivider
      className="p-md bordered"
      containerClassName="lg:px-none px-md pb-md"
    >
      {paymentOptions.map((item, index) => (
        <PaymentMethod
          id={item.payment_method_id}
          name={item.name}
          extra={<PaymentMethodBrandIcons {...item} className="h-4 my-auto" />}
          isSelected={item.payment_method_id === selectedPaymentMethod}
          isDisabled={loading}
          onClick={() => onPaymentMethodClick(item.payment_method_id)}
          key={`payment-method-option-${item.payment_method_id}`}
          className={classnames({
            'border-t-none': index > 0 && item.payment_method_id !== selectedPaymentMethod,
            'rounded-t-2xl': index === 0,
            'rounded-b-2xl': index === paymentOptions.length - 1,
          })}
        />
      ))}
    </Section>
  );
}
